// src/components/WeatherBadge.jsx
import React from 'react';

/**
 * WeatherBadge - Displays weather icon and temperature
 * @param {string} condition - Weather condition ('Clear', 'Rain', 'Clouds', 'Snow', etc.)
 * @param {number} temperature - Temperature in Celsius
 * @param {string} size - Size variant ('sm', 'md', 'lg')
 */
export default function WeatherBadge({ condition, temperature, size = 'md' }) {
  // If no weather data, don't render
  if (condition === null || condition === undefined || temperature === null || temperature === undefined) {
    return null;
  }

  const roundedTemp = Math.round(temperature);

  const getWeatherIcon = (cond) => {
    const conditionLower = (cond || '').toLowerCase();
    
    if (conditionLower.includes('clear') || conditionLower.includes('sun')) {
      return '☀️';
    } else if (conditionLower.includes('rain') || conditionLower.includes('drizzle')) {
      return '🌧️';
    } else if (conditionLower.includes('snow')) {
      return '❄️';
    } else if (conditionLower.includes('cloud')) {
      return '☁️';
    } else if (conditionLower.includes('storm') || conditionLower.includes('thunder')) {
      return '⛈️';
    } else if (conditionLower.includes('fog') || conditionLower.includes('mist')) {
      return '🌫️';
    } else if (conditionLower.includes('wind')) {
      return '💨';
    } else {
      return '🌤️'; // Partly cloudy as default
    }
  };

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className={`flex items-center gap-1 ${sizeClasses[size]}`} title={`${condition}, ${roundedTemp}°C`}>
      <span className="text-xl" role="img" aria-label={condition}>
        {getWeatherIcon(condition)}
      </span>
      <span className="font-medium text-content-primary">
        {roundedTemp}°C
      </span>
    </div>
  );
}
